import { environment } from "./../../../environments/environment";
import { TeamService } from "./../../services/settings-service/team/team.service";
import { ReservationService } from "./../../services/reservation-service/reservation.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { Component, OnInit } from "@angular/core";
import swal from "sweetalert2";

@Component({
  selector: "app-broker-wallet",
  templateUrl: "./broker-wallet.component.html",
  styleUrls: ["./broker-wallet.component.css"],
})
export class BrokerWalletComponent implements OnInit {
  filter_expand = false;
  filterForm: FormGroup;
  brokerWallet: any;
  pageTest: any = 1;
  lg: any = "lg";
  last_page_url: any;
  brokers: any;
  teams: any;
  projects: any;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  current_balance: any;
  has_filter_data: boolean = false;
  current_commission: any;
  current_wallet_id: any;
  excel: any;

  coming_soon: boolean = true;

  active_tab = "all";

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private teamService: TeamService
  ) {}

  ngOnInit() {
    if (this.userData.role !== "Property Consultant") {
      this.getBrokers();
    }
    this.getProjects();

    this.setActiveTab("all");
  }

  setActiveTab(tab) {
    this.active_tab = tab;
    let userId = "";
    switch (tab) {
      case "me": {
        userId = this.userData.id;
      }
    }
    if (this.userData.role == "Admin" || this.userData.role === "CFO") {
      this.adminCreateForm(userId);
      this.exportWallet();
    } else {
      this.userCreateFilterForm(userId);
    }
    this.getBrokersWallet();
  }

  adminCreateForm(userId?) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      team_id: [""],
      project_id: [""],
      commissioned_for: [userId || ""],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      direction: ["external"],
    });
  }

  userCreateFilterForm(userId) {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      project_id: [""],
      commissioned_for: [userId || ""],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      direction: ["external"],
    });
  }

  getBrokersWallet() {
    let payload = this.filterForm.value;
    this.slimLoadingService.start();
    this.userService.getBrokersWallet(payload).subscribe(
      (res: any) => {
        this.brokerWallet = res;
        this.last_page_url = res.wallets.last_page_url;
        this.slimLoadingService.complete();
        this.exportWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  getBrokers() {
    this.slimLoadingService.start();
    this.userService.getBrokersWallets().subscribe(
      (res: any) => {
        this.brokers = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getProjects() {
    this.slimLoadingService.start();
    this.reservationService.getProjects().subscribe(
      (data) => {
        this.projects = data;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.slimLoadingService.complete();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getWallet() {
    let payload = this.filterForm.value;
    this.slimLoadingService.start();
    this.userService.filterWallet(payload).subscribe(
      (res: any) => {
        this.brokerWallet = res;
        this.last_page_url = res.wallets.last_page_url;
        this.slimLoadingService.complete();
        this.exportWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  pageChange(event) {
    console.log(event);
    console.log(this.last_page_url);
    if (this.last_page_url) {
      let arr = this.last_page_url.split("?");
      let selectedUrl = `${arr[0]}?page=${event}`;
      this.infinite(selectedUrl, event);
    }
  }

  infinite(url, event) {
    this.slimLoadingService.start();
    this.userService.infinit(url, this.filterForm.value).subscribe(
      (res: any) => {
        this.brokerWallet = res;
        this.last_page_url = res.wallets.last_page_url;
        this.slimLoadingService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  resetFilter() {
    this.setActiveTab(this.active_tab);
    this.getBrokersWallet();
  }

  payWallet(id) {
    this.slimLoadingService.start();
    this.userService.payWallet(id).subscribe(
      (res: any) => {
        this.slimLoadingService.complete();
        this.getBrokersWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  exportWallet() {
    let data = this.filterForm.value;
    this.excel = `${
      environment.api_base_url
    }wallets?excel=1&token=${window.localStorage.getItem("token")}`;

    Object.entries(data).map(([key, value]) => {
      if (value) {
        this.excel += `&${key}=${value}`;
      }
    });
  }

  approveWallet(id) {
    const payload = {
      ids: [id],
    };
    this.slimLoadingService.start();
    this.userService.approveWallet(payload).subscribe(
      (res: any) => {
        swal("Success", "approved successfully", "success");
        this.slimLoadingService.complete();
        this.getBrokersWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/broker-wallet/broker-wallet.component.ts